// React
import React from 'react';

// Packages

// Utilities
import { getYears } from 'utilities';
import { useLabels } from 'utilities/hooks';
import { CONSTANTS } from 'utilities/configuration';

// Components
import {
    ResultReflections,
    ResultDetails,
    ResultChoice,
    ResultDataCard,
    ResultSetFieldValues,
} from '../_common';
import { ResultsInventionDisclosureDetails } from 'components/_cardContents/resultsInventionDisclosure/resultsInventionDisclosure';

const Name = CONSTANTS.RESULTS.INVENTION_DISCLOSURE;

const Choice = props => {
    return ResultChoice({
        Name,
        methods: 'Initiative_Result__c.Invention_Type__c',
        fieldName: 'Invention_Type__c',
        ...props,
    });
};

const DataCard = ({ item, theme = 'teal', mode = [] }) => {
    return (
        <ResultDataCard
            {...{
                item,
                theme,
                methodsFieldName: 'Invention_Type__c',
                showDetails: mode.includes('details'),
            }}>
            <ResultsInventionDisclosureDetails {...{ item, theme }} />
        </ResultDataCard>
    );
};
const Details = props => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object } = useLabels();

    // ///////////////////
    // METHODS
    // ///////////////////

    function getItemData(formData) {
        const {
            Invention_Type__c,
            Year__c,
            Ownership__c,
            Commercialisation__c,
        } = formData;

        // Data for sf
        return {
            Invention_Type__c,
            Year__c: Year__c?.length > 0 ? Year__c : null,
            Ownership__c,
            Commercialisation__c,
        };
    }

    // ///////////////////
    // FIELDS
    // ///////////////////

    function fields() {
        return [
            {
                type: 'Select',
                name: 'Year__c',
                object: object.config(
                    'Initiative_Result__c.Year__c___Invention_Disclosure'
                ),
                options: getYears(),
            },
            {
                type: 'Toggle',
                name: 'Ownership__c',
                object: object.config('Initiative_Result__c.Ownership__c'),
            },
            {
                type: 'Toggle',
                name: 'Commercialisation__c',
                object: object.config(
                    'Initiative_Result__c.Commercialisation__c'
                ),
            },
        ];
    }

    // ///////////////////
    // RETURN
    // ///////////////////

    return ResultDetails({
        fields,
        fieldSuffix: '___Invention_Disclosure',
        getItemData,
        ...props,
    });
};

const Reflections = props => {
    return ResultReflections({
        ...props,
    });
};

const setFieldValues = ({ choice, form, id, utilities, REPORT_ID }) => {
    // ///////////////////
    // DETAILS
    // ///////////////////

    const {
        Invention_Type__c,

        Ownership__c,
        Commercialisation__c,
        Year__c,
    } = utilities.results.get(id);

    // Choice
    form.setValue('Invention_Type__c', Invention_Type__c);

    form.setValue('Ownership__c', Ownership__c);
    form.setValue('Commercialisation__c', Commercialisation__c);
    form.setValue('Year__c', Year__c);

    // ///////////////////
    // ALL THE OTHER STUFF
    // ///////////////////

    ResultSetFieldValues({
        choice,
        form,
        id,
        utilities,
        REPORT_ID,
    });
};

export { Name, DataCard, Choice, Details, Reflections, setFieldValues };
